import { getIntegrationProviderDisplayName } from '@/modules/assetProviderIntegrations/shared/constants';
import { useIsAssetProviderIntegrationEnabled } from '@/modules/assetProviderIntegrations/shared/hooks/useEnabledAssetsIntegrations';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { useTenantDetailsContext } from '@/modules/tenant/TenantDetailsContext/TenantDetailsContext';

export function useHouseholdConnectionDetails() {
  const { assetIntegrationsEnabled } = useTenantDetailsContext();
  const { linkedHouseholdAssetProvider } = useHouseholdDetailsContext();
  const { canConnectToIntegrations, integrationsConnected } =
    useIsAssetProviderIntegrationEnabled();

  const integrationConnected = Boolean(linkedHouseholdAssetProvider);
  const integrationDisplayName = linkedHouseholdAssetProvider
    ? getIntegrationProviderDisplayName(linkedHouseholdAssetProvider)
    : 'an integration';
  const integrationAvailable = assetIntegrationsEnabled;

  const showIntegrationPromptCard = (() => {
    // if not allowed for the tenant (e.g. go-tier tenant without the integrations add-on); don't show ever
    if (!assetIntegrationsEnabled) {
      return false;
    }

    if (
      integrationsConnected.length === 0 &&
      canConnectToIntegrations.length === 0
    ) {
      return false;
    }

    // otherwise, we're connected to an integration and can show the prompt card!
    return true;
  })();

  return {
    integrationDisplayName,
    integrationAvailable,
    integrationConnected,
    showIntegrationPromptCard,
  };
}
